import config from "config";
import { logout } from "context/UserAuthContext";
import { isJsonString } from "./functions";

export const apiRequest = (method, url, formData = null, additionalHeaders = {}, additionalOptions = {}) => {
    const isExternal = url.indexOf('https://') !== -1;
    const options = {
        method: method,
        ...additionalOptions
    };
    let headers = {};
    if (!isExternal) {
        const token = localStorage.getItem('token');
        if (token) {
            headers = {
                ...headers,
                Authorization: 'Basic ' + token
            }
        }
    }
    if (formData) {
        options.body = formData;
        headers = {
            ...headers,
            // 'Content-Type': 'application/x-www-form-urlencoded'
        }
    }
    headers = {
        ...headers,
        ...additionalHeaders
    }
    options.headers = new Headers(headers)
    const fullUrl = isExternal ? url : config.apiUrl + url;
    return fetch(fullUrl, options)
        .then((resp) => {
            if (resp.status === 401) {
                (async () => {
                    if(url !== '/login'){
                        await logout();
                    }
                    return resp.json();
                })();

            } else {
                if(isExternal){
                    return resp;
                }
                return resp.json();
            }
        })
        .then((d) => {
            if (!isExternal && d && d.response) {
                return d.response;
            }
            return d;
        })
}

export const getRequest = (url) => {
    return apiRequest('get', url, null, {
        'Accept': 'application/json',
    });
}

export const postRequest = (url, formData = null) => {
    let fd = formData;
    if(typeof formData === 'object' && !(formData instanceof FormData)){
        fd = new FormData();
        for(var k in formData){
            fd.append(k, formData[k]);
        }
    }
    return apiRequest('post', url, fd, {
        'Accept': 'application/json',
    });
}

export const putRequest = (url, formData = null, optionalHeaders = {}) => {
    return apiRequest('put', url, formData, {
        ...optionalHeaders
    });
}

export const deleteRequest = (url, formData = null) => {
    return apiRequest('delete', url, formData, {
        'Accept': 'application/json',
    });
}
export const fileUploadRequest = (url, file, optionalHeaders = {}) => {
    return apiRequest('put', url, null, optionalHeaders, {body: file, mode: "cors"});
}